import { Link } from "react-router-dom";
const HomeContact = () => {
  return <section className="relative w-full overflow-hidden bg-white py-16 sm:py-20 lg:py-28 mb-4">
            <img
    src="/images/Hiru/public_images/eyJidWNrZXQiOiJmaXRyZWlzZW4tY2RuLWltYWdlcyIsImtleSI6IkMyNEI1NEI1QjgwODc1MEZEODg0QzkzOEU1RjE4RkZEIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxMjAwLCJoZWlnaHQiOjkwMCwiZml0IjoiY292ZXIiLCJwb3NpdGlvbiI6ImF0dGVudGlvbiJ9fX0=.webp"
    alt="Hintergrundbild für Kontakt"className="object-cover object-center scale-[1.03]" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70" />

            <div className="relative z-10 container mx-auto px-4">
                <div className="mx-auto flex min-h-[360px] max-w-5xl items-center justify-center sm:min-h-[420px] lg:min-h-[520px]">
                    <div className="w-full max-w-4xl p-4 text-center text-white sm:p-6 lg:px-10 lg:py-8">
                        <div className="mx-auto mb-6 h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />

                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-amber-100/90">
                            Kontakt
                        </p>

                        <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
                            Von der Anfrage bis zur Reservierung
                            <br className="hidden sm:block" />
                            nehmen Sie gerne Kontakt mit uns auf.
                        </h2>

                        <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-white/88 sm:text-base lg:text-lg">
                            Sie können uns alles mitteilen, was Sie interessiert – von Ihrer gewünschten Unterkunft bis zu Ihren Ayurveda-Behandlungswünschen.
                        </p>

                        <p className="mx-auto mt-4 max-w-2xl text-[14px] leading-relaxed text-white/72 sm:text-[15px]">
                            Wir beantworten Ihre Nachricht so schnell und freundlich wie möglich. Selbst in der Vorbereitungsphase Ihrer Reise können Sie uns einfach kontaktieren.
                        </p>

                        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5">
                            <Link
    to="/contact-us"
    className="group inline-flex items-center justify-center rounded-full bg-gradient-to-r from-[#F28600] to-[#ff9a1f] px-8 py-4 text-sm font-semibold text-white shadow-[0_18px_50px_-22px_rgba(242,134,0,0.9)] transition hover:translate-y-[-1px] hover:from-[#ff9814] hover:to-[#f28600] active:scale-[0.99]"
  >
                                Bei Fragen kontaktieren Sie uns gerne
                            </Link>

                            <span className="text-xs font-medium uppercase tracking-[0.3em] text-white/55 sm:text-sm">
                                Wir unterstützen Sie persönlich
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default HomeContact;
